import { SideBarDef } from "ag-grid-community";

export function axeCreationSidebar({
  theme,
  getAccessTokenSilently,
}: {
  theme: string | undefined;
  getAccessTokenSilently: Function;
}): SideBarDef {
  return {
    toolPanels: [
      {
        id: "generateAxes",
        labelDefault: "Generate Axes",
        labelKey: "generateAxes",
        iconKey: "columns", //todo add cool axe icon
        toolPanel: "customConfigsToolPanel",
        toolPanelParams: {
          theme,
          getAccessTokenSilently,
        },
        // minWidth: 200,
        // maxWidth: 800,
        width: 250,
      },
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        minWidth: 225,
        maxWidth: 225,
        width: 300,
        toolPanelParams: {
          suppressPivotMode: true,
          suppressRowGroups: true,
          suppressValues: true,
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
        minWidth: 180,
        maxWidth: 400,
        width: 300,
      },
    ],
    defaultToolPanel: "generateAxes",
    position: `left`,
  };
}
